export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/72788400e49fbda6976942ad945b6017.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-8 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="text-white space-y-8">
            <h1 className="text-7xl font-bold leading-tight">
              Secure Your<br />Digital Life
            </h1>
            <p className="text-xl text-gray-200 leading-relaxed max-w-xl">
              Experience ultimate online privacy and security with our advanced VPN technology. Browse anonymously, protect your data, and access content freely from anywhere in the world.
            </p>
            <div className="flex items-center space-x-4 pt-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="px-8 py-4 bg-white text-gray-900 rounded-full text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 shadow-xl whitespace-nowrap"
              >
                Get Started
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white/10 transition-all whitespace-nowrap"
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="hidden lg:flex justify-center items-center">
            <div className="relative transform rotate-6 hover:rotate-0 transition-transform duration-500">
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500/20 to-purple-600/20 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20VPN%20application%20interface%20mockup%20showing%20connection%20dashboard%20with%20world%20map%2C%20server%20locations%2C%20and%20security%20status%20indicators%20on%20dark%20theme%2C%20clean%20UI%20design%20with%20glowing%20teal%20and%20purple%20accents%2C%20professional%20software%20screenshot%20with%20connection%20button%20and%20speed%20metrics%2C%20minimalist%20app%20interface%20with%20elegant%20typography%20and%20smooth%20gradients&width=600&height=800&seq=hero-mockup-001&orientation=portrait"
                alt="VPN Application Interface"
                className="relative rounded-3xl shadow-2xl w-full max-w-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
